import { render } from "./FicheRecensementPage.vue?vue&type=template&id=4eaffd16&ts=true"
import script from "./FicheRecensementPage.vue?vue&type=script&lang=ts"
export * from "./FicheRecensementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__